function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import inc from 'fkit/dist/inc';
import update from 'fkit/dist/update';
import createContext from './createContext';
import incrementCounters from './incrementCounters';
import placePromos from './placePromos';
import { setUser } from './userState';
import { timestamp } from './utils'; // Increments the number of visits for the user.

var incrementVisits = update('visits', inc); // Adds the given promo to the list of blocked promos for the user.

var blockPromo = incrementCounters('blocked'); // Tracks an impression for the given promo.

var trackImpression = incrementCounters('impressions'); // Tracks an engagement for the given promo.

var trackEngagement = incrementCounters('engagements');
/**
* Return a transform function that takes a state, an event, and an emitter
* object. When called, the transform function returns a new state and optionally
* emits an event.
 *
 * @param {Storage} storage The storage object.
 * @param {Array} promos The list of promos.
 * @returns A new state.
 */

export default function stateMachine(storage, promos) {
  return function (_ref, event) {
    var seeds = _ref.seeds,
        user = _ref.user,
        custom = _ref.custom;
    var ts = timestamp();
    var customState = event.custom || custom; // Update the user state based on the event type.

    if (event.type === 'visit') {
      user = incrementVisits(user);
    } else if (event.type === 'click') {
      user = trackEngagement(ts, event.promo)(user);
    } else if (event.type === 'close') {
      user = blockPromo(ts, event.promo)(user);
    } else if (event.type === 'view') {
      user = trackImpression(ts, event.promo)(user);
    } else if (event.type === 'donationsLoaded') {
      user = _objectSpread({}, user, {
        donations: event.donations
      });
    } else if (event.type === 'newslettersLoaded') {
      user = _objectSpread({}, user, {
        newsletters: event.newsletters
      });
    }

    var placedPromos = null; // Place and emit the promos.

    if (event.type === 'visit' || event.type === 'refresh') {
      var context = createContext(user, customState);
      placedPromos = placePromos(seeds, promos, context);
    } // Store the user state as a side effect.


    setUser(storage, user);
    return {
      seeds: seeds,
      user: user,
      custom: customState,
      promos: placedPromos
    };
  };
}